import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=51d2bff1&scoped=true&"
import script from "./OrderPreview.vue?vue&type=script&lang=js&"
export * from "./OrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=51d2bff1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2bff1",
  null
  
)

export default component.exports